import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";

const state = {
    employees: [],
    employee: {},
    totalItems:0,

};

const getters = {
    index: state => qualificationId => state.employees.findIndex(i => i.qualificationId === qualificationId)
};

const mutations = {
    setEmployees: (state, r) => (state.employees = r),
    setEmployee: (state, r) => (state.employee = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    add: (state, r) => state.employees.unshift(r),
    //edit: (state, {index,  r }) => state.employees.splice(index, 1, r),
    //edit: (state, { r }) => state.employees.splice(1, 1, r),
    delete: (state, index) => state.employees.splice(index, 1),

};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.employeeQualifications.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployees", response.data.employees);
            commit("setTotalItems", response.data.totalItems);


        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setEmployee", {});
            startLoading()
            const response = await dataService.employeeQualifications.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployee", response.data.employee);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.employeeQualifications.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.employee);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, id) {
        try {
            startLoading()
            const response = await dataService.employeeQualifications.add(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            commit("add", response.data.employee);


        } catch (error) {
            console.log(error)
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async edit(_, { id, payload }) {
        try {
            let formData = new FormData()

            //const formData = new FormData();
            formData.append("employeeId", payload.employeeId);
            payload.items.forEach((tag, index) => {
                formData.append(`Items[${index}].qualificationDetailsId`, tag.qualificationDetailsId);
                formData.append(`Items[${index}].qualificationDetailsName`, tag.qualificationDetailsName);
                formData.append(`Items[${index}].specialtyId`, tag.specialtyId);
                formData.append(`Items[${index}].sourceTypeId`, tag.sourceTypeId);
                formData.append(`Items[${index}].sourceId`, tag.sourceId);
                formData.append(`Items[${index}].qualificationDate`, tag.qualificationDate);
                formData.append(`Items[${index}].qualificationAttachment`, tag.qualificationAttachment);
                formData.append(`Items[${index}].fileName`, tag.fileName);
            });
            startLoading()
            const response = await dataService.employeeQualifications.edit(id, formData);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);

            return Promise.resolve()
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeeQualifications.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async search(_, employmentNo) {
        try {

            //startLoading()
            //const response = await dataService.employees.search(id);
            //stopLoading()

            //if (!response.data.statusCode) {
            //    showAlert(serverErrorMessage);
            //    return;
            //}
            let employee = {
                employeeId: 2,
                fullName: " محمد عبدالله",
                nationalNo: "112003225125",
            }
            console.log(employmentNo)
            return Promise.resolve(employee);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },


};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
